import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtNZD, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/hsUtil";

export default function AcceptQuote({ project, subtotal }) {
  const { user } = useAuth();
  const { reload } = useOutletContext() || {};
  const [acceptedAt, setAcceptedAt] = useState(project.quote_accepted_at);
  if (user?.role !== "Admin" || project.job_type === "quick") return null;
  async function accept() {
    const msg = acceptedAt
      ? `Quote changed since acceptance. Add the difference as an approved variation?`
      : `Accept this quote? Original contract value becomes ${fmtNZD(subtotal)} ex GST and this version is locked.`;
    if (!window.confirm(msg)) return;
    try {
      const { data } = await api.post(`/projects/${project.id}/estimate/accept`);
      if (data.variation_ex !== undefined) toast.success(`Approved variation added: ${fmtNZD(data.variation_ex)} ex GST`);
      else { setAcceptedAt(data.accepted_at); toast.success(`Quote accepted. Contract ${fmtNZD(data.contract_ex)} ex GST`); }
      reload?.();
    } catch (e) { toast.error(errMsg(e)); }
  }
  return (
    <div className="flex items-center gap-3 mt-3" data-testid="accept-quote-bar">
      {acceptedAt && <span className="text-green-400 text-sm" data-testid="quote-accepted-label">Accepted {fmtDate(acceptedAt)}</span>}
      <button className="btn-silver text-sm" onClick={accept} data-testid="accept-quote-btn">{acceptedAt ? "Add quote changes as variation" : "Accept quote"}</button>
    </div>
  );
}
